import { useEffect, useMemo } from "react";
import {
  Heading6,
  Icon,
  ImageLite,
  PageLink,
  Paragraph,
} from "shared/components";
import { useLazyRenderingState } from "shared/components/LazyRenderingButton";
import { useTabsState } from "shared/components/Tabs/Tabs.hooks";

import styles from "./LecturersList.module.scss";

export const LecturersList = ({
  people,
  activePositionTab,
  tabsHeaderEnabled,
}) => {
  const { limit, resetState } = useLazyRenderingState();
  const { activeTab, tabsEnabled, isDefaultTab } = useTabsState();

  const filteredLecturers = useMemo(() => {
    if (!tabsEnabled || isDefaultTab) {
      return people;
    }

    return people.filter(({ tags }) => tags?.includes(activeTab));
  }, [tabsEnabled, isDefaultTab, people, activeTab]);

  const filteredLecturersByPosition = useMemo(() => {
    return filteredLecturers.filter(
      ({ position }) =>
        position?.toLowerCase() === activePositionTab?.toLowerCase()
    );
  }, [activePositionTab, filteredLecturers]);

  const slicedLecturers = useMemo(() => {
    if (tabsHeaderEnabled) {
      return filteredLecturersByPosition.slice(0, limit);
    }
    return filteredLecturers.slice(0, limit);
  }, [
    filteredLecturers,
    filteredLecturersByPosition,
    limit,
    tabsHeaderEnabled,
  ]);

  useEffect(() => {
    resetState();
  }, [activeTab, resetState]);

  return slicedLecturers.map(({ person }) => (
    <div key={person.id} className={styles.item}>
      <PageLink directory="teachers" slug={person.slug}>
        <div className={styles["item-wrap"]}>
          <div className={styles.photo}>
            <ImageLite image={person.photo} className={styles.image} />
            {person.teacherType && (
              <span className={styles.type}>{person.teacherType}</span>
            )}
          </div>
          <div className={styles.teacher}>
            <Heading6 as="h6" className={styles.title}>
              {person.title}
            </Heading6>
            <Paragraph className={styles.description} color="dark">
              {person.description}
            </Paragraph>
            <Icon className={styles.icon} name="arrow_right" />
          </div>
        </div>
      </PageLink>
    </div>
  ));
};
